<template>
    <div class="page-container">
        <el-row style="margin-top: 2vh;padding: 0 20px;">
            <el-col :span="24">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <el-form-item label="菜品名称">
                        <el-input v-model="formInline.dishName" placeholder="菜品名称"></el-input>
                    </el-form-item>

                    <el-form-item label="价格排序">
                        <el-select v-model="priceSort" placeholder="排序方式" @change="onSubmit">
                            <el-option label="不排序" value=""></el-option>
                            <el-option label="从低到高" value="asc"></el-option>
                            <el-option label="从高到低" value="desc"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" @click="onSubmit()">查询</el-button>
                        <el-button icon="el-icon-refresh" @click="resetSearch()">重置</el-button>
                        <el-button type="primary" icon="el-icon-plus" @click="openAddModal()">新增</el-button>
                    </el-form-item>
                </el-form>
            </el-col>

            <!-- 卡片式展示区域 -->
            <el-col :span="24" class="card-container-wrapper">
                <div class="card-container">
                    <el-row :gutter="20">
                        <!-- 循环渲染卡片 -->
                        <el-col v-for="(item, index) in filteredExamples" :key="index" :span="5" class="card-item">
                            <el-card :class="['dish-card', index % 2 === 0 ? 'card-even' : 'card-odd']" shadow="hover">
                                <div class="card-body">
                                    <!-- 菜品图片 -->
                                    <div class="dish-image">
                                        <img :src="item.coverImg" :alt="item.dishName + '图片'" class="dish-photo">
                                        <div class="price-tag">¥{{ item.price.toFixed(2) }}</div>
                                    </div>
                                    <!-- 菜品信息 -->
                                    <div class="dish-info">
                                        <p class="dish-name"><i class="el-icon-cutlery"></i> {{ item.dishName }}</p>
                                        <p><i class="el-icon-fire"></i> 热量: {{ item.calorie }}kcal</p>
                                        <p><i class="el-icon-time"></i> 烹饪时间: {{ item.duringTime }}分钟</p>
                                        <!-- 显示简短介绍 -->
                                        <p class="dish-desc"><i class="el-icon-info"></i>
                                            {{ item.introduction ? (item.introduction.length > 20 ?
                                                item.introduction.substring(0, 20) + '...' : item.introduction) : '无介绍' }}
                                        </p>
                                    </div>
                                    <!-- 操作按钮 -->
                                    <div class="card-actions">
                                        <!-- 点击打开详情抽屉 -->
                                        <el-button size="mini" @click="openDetailDrawer(item)" type="primary"
                                            icon="el-icon-picture">详情</el-button>
                                        <el-button size="mini" @click="openEditModal(item)" type="success"
                                            icon="el-icon-edit">修改</el-button>
                                        <el-button size="mini" @click="deleteDish(item)" type="danger"
                                            icon="el-icon-delete">删除</el-button>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                    <!-- 无数据提示 -->
                    <div v-if="filteredExamples.length === 0" class="no-data">
                        <el-empty introduction="暂无菜品数据"></el-empty>
                    </div>
                </div>

                <!-- 分页控件 -->
                <div class="pagination-container">
                    <el-pagination align="center" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[5, 10, 15, 20]" :page-size="pageSize" background
                        layout="total, sizes, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>

        <!-- 1. 新增/编辑菜品弹窗 -->
        <el-dialog :title="dialogTitle" :visible.sync="addModalVisible" width="70%" :close-on-click-modal="false"
            custom-class="dish-modal" :modal-append-to-body="false" :append-to-body="true">
            <el-tabs v-model="addActiveTab" class="add-dish-tabs">
                <el-tab-pane label="基本信息" name="baseInfo">
                    <el-form ref="addForm" :model="addForm" :rules="dishRules" label-width="120px" class="dish-form">
                        <el-form-item label="菜品名称" prop="dishName">
                            <el-input v-model="addForm.dishName" placeholder="请输入菜品名称"></el-input>
                        </el-form-item>
                        <el-form-item label="菜品编号" prop="dishCode">
                            <el-input v-model="addForm.dishCode" placeholder="请输入菜品编号"></el-input>
                        </el-form-item>
                        <el-form-item label="菜品类型" prop="category">
                            <el-input v-model="addForm.category" placeholder="请输入菜品类型(热菜、凉菜等)"></el-input>
                        </el-form-item>

                        <el-form-item label="功能间" prop="room">
                            <el-select v-model="addForm.room" placeholder="选择功能间">
                                <el-option v-for="room in roomList" :key="room.id" :label="room.roomName"
                                    :value="room.roomName"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="价格" prop="price">
                            <el-input v-model.number="addForm.price" placeholder="请输入菜品价格"
                                prefix-icon="el-icon-money"></el-input>
                        </el-form-item>
                        <el-form-item label="热量" prop="calorie">
                            <el-input v-model.number="addForm.calorie" placeholder="请输入热量(千卡)" suffix="kcal"></el-input>
                        </el-form-item>
                        <!-- 新增菜品介绍字段 -->
                        <el-form-item label="菜品介绍" prop="introduction">
                            <el-input v-model="addForm.introduction" type="textarea"
                                placeholder="请输入菜品详细介绍，包括口味特点、历史背景等"></el-input>
                        </el-form-item>
                        <el-form-item label="菜品图片">
                            <el-upload class="upload-demo" action="#" :auto-upload="false"
                                :on-change="handleImageChange" :file-list="addFileList" list-type="picture-preview">
                                <el-button size="small" type="primary">选择图片</el-button>
                                <div slot="tip" class="el-upload__tip">支持JPG/PNG格式，大小不超过200k,图片比例3:2</div>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
                <!-- 选择烹饪设备 -->
                <el-tab-pane label="烹饪设备" name="menu">
                    <el-form :model="form" ref="form" label-width="120px" :rules="formRules">
                        <!-- 第二行：设备类型 + 单重量 -->
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="烹饪设备" prop="cookingEquipment">
                                    <el-select v-model="addForm.cookingEquipment" placeholder="请选择烹饪设备（可多选）" multiple
                                        clearable style="width: 100%;">
                                        <!-- 循环渲染可选设备 -->
                                        <el-option v-for="device in cookDeviceList" :key="device.value"
                                            :label="device.label" :value="device.value"></el-option>
                                    </el-select>
                                    <div class="el-form-item__help">提示：可按住Ctrl键（Windows）/Command键（Mac）多选</div>
                                </el-form-item>
                            </el-col>

                        </el-row>

                        <!-- 👇 关键修改：添加 v-if 条件判断 -->
                        <div v-if="hasCookerMachine">
                            <!-- 第三行：份数 + 单重量 -->
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="份数" prop="dishCount">
                                        <el-input v-model.number="form.dishCount"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="单重量" prop="dishWeight">
                                        <el-input v-model.number="form.dishWeight"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <!-- 第四行：炒菜总需时间 + （空列，用于对齐） -->
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="炒菜总需时间" prop="duringTime">
                                        <el-input v-model.number="form.duringTime"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="是否是常用菜" prop="isCommon">
                                        <el-radio v-model="form.isCommon" :label="1">是</el-radio>
                                        <el-radio v-model="form.isCommon" :label="0">否</el-radio>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <!-- 制作步骤部分（保持原有逻辑） -->
                            <el-form-item label="制作步骤">
                                <div v-for="(step, index) in form.stepBeans" :key="index" class="step-item">
                                    <h4>步骤 {{ index + 1 }}</h4>
                                    <el-row :gutter="20">
                                        <el-col :span="8">
                                            <el-form-item label="步骤类型">
                                                <el-radio v-model="step.type" :label="STEP_TYPES.POT">锅</el-radio>
                                                <el-radio v-model="step.type"
                                                    :label="STEP_TYPES.SEASONING">调味料</el-radio>
                                                <el-radio v-model="step.type"
                                                    :label="STEP_TYPES.SOLID_BOX">固体料盒</el-radio>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="时间" :prop="`stepBeans[${index}].time`"
                                                :rules="timeRules">
                                                <el-input v-model.number="step.time"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="火力值" :prop="`stepBeans[${index}].firepower`"
                                                :rules="firepowerRules">
                                                <el-input v-model.number="step.firepower"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="20">
                                        <el-col :span="8">
                                            <el-form-item label="速度" v-if="step.type === STEP_TYPES.POT"
                                                :prop="`stepBeans[${index}].speed`" :rules="speedRules">
                                                <el-radio v-model="step.speed" :label="'停止'">停止</el-radio>
                                                <el-radio v-model="step.speed" :label="'低速'">低速</el-radio>
                                                <el-radio v-model="step.speed" :label="'中速'">中速</el-radio>
                                                <el-radio v-model="step.speed" :label="'高速'">高速</el-radio>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="抬起/放下" v-if="step.type === STEP_TYPES.POT"
                                                :prop="`stepBeans[${index}].liftDown`" :rules="liftDownRules">
                                                <el-radio v-model="step.liftDown" :label="'up'">抬起</el-radio>
                                                <el-radio v-model="step.liftDown" :label="'down'">放下</el-radio>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="温度" v-if="step.type === STEP_TYPES.POT"
                                                :prop="`stepBeans[${index}].temperature`" :rules="temperatureRules">
                                                <el-input v-model.number="step.temperature"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="20">
                                        <el-col :span="8">
                                            <el-form-item label="一份的系数" :prop="`stepBeans[${index}].oneseasonMultiple`"
                                                :rules="coefficientRules">
                                                <el-input v-model.number="step.oneseasonMultiple"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="两份的系数"
                                                :prop="`stepBeans[${index}].doubleseasonMultiple`"
                                                :rules="coefficientRules">
                                                <el-input v-model.number="step.doubleseasonMultiple"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="三份的系数"
                                                :prop="`stepBeans[${index}].tripleseasonMultiple`"
                                                :rules="coefficientRules">
                                                <el-input v-model.number="step.tripleseasonMultiple"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-form-item v-if="step.type === STEP_TYPES.SEASONING" label="配料">
                                        <el-table :data="step.ingredients" border style="width: 100%">
                                            <el-table-column prop="id" label="序号" width="80"></el-table-column>
                                            <el-table-column prop="seasonerName" label="配料名称">
                                                <template slot-scope="scope">
                                                    <el-input v-model="scope.row.seasonerName" size="mini"></el-input>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="weight" label="调味料重量">
                                                <template slot-scope="scope">
                                                    <el-input v-model.number="scope.row.weight" size="mini"></el-input>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="num" label="管道id">
                                                <template slot-scope="scope">
                                                    <el-input v-model.number="scope.row.num" size="mini"></el-input>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="oneseasonMultiple" label="一份的系数">
                                                <template slot-scope="scope">
                                                    <el-input v-model.number="scope.row.oneseasonMultiple"
                                                        size="mini"></el-input>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="doubleseasonMultiple" label="两份的系数">
                                                <template slot-scope="scope">
                                                    <el-input v-model.number="scope.row.doubleseasonMultiple"
                                                        size="mini"></el-input>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="tripleseasonMultiple" label="三份的系数">
                                                <template slot-scope="scope">
                                                    <el-input v-model.number="scope.row.tripleseasonMultiple"
                                                        size="mini"></el-input>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="操作" width="80">
                                                <template slot-scope="scope">
                                                    <el-button type="text" size="mini"
                                                        @click="handleDeleteIngredient(step, scope.row, index)">删除</el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <el-button type="primary" size="small" @click="addNewIngredientRow(step)">+
                                            添加配料</el-button>
                                    </el-form-item>
                                    <el-row :gutter="20">
                                        <el-col :span="8">
                                            <el-form-item v-if="step.type === STEP_TYPES.SOLID_BOX" label="固体料盒序号"
                                                :prop="`stepBeans[${index}].solidBoxIndex`" :rules="[
                                                    { required: true, message: '请输入固体料盒序号', trigger: 'blur' },
                                                    { type: 'number', message: '序号必须为数字', trigger: 'blur' }
                                                ]">
                                                <el-input v-model.number="step.solidBoxIndex"
                                                    placeholder="请输入料盒序号"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-button type="danger" @click="handleDeleteStep(index)">删除该步骤</el-button>
                                </div>
                                <el-button type="primary" @click="handleAddStep(STEP_TYPES.POT)">+ 添加步骤-锅</el-button>
                                <el-button type="primary" @click="handleAddStep(STEP_TYPES.SEASONING)">+
                                    添加步骤-调味料</el-button>
                                <el-button type="primary" @click="handleAddStep(STEP_TYPES.SOLID_BOX)">+
                                    添加步骤-固体料盒</el-button>
                            </el-form-item>
                        </div>
                        <!-- 👆 结束条件判断 -->
                        <!-- 👇 修改条件判断：检测蒸柜关键词 -->
                        <div v-if="hasSteamerCabinet">
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="做菜总需时间" prop="minute">
                                        <el-input v-model.number="form.minute" placeholder="请输入做菜总需时间"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="温度" prop="temperature">
                                        <el-input v-model.number="form.temperature" placeholder="请输入温度"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="菜品图片" prop="operaInCabPic">
                                        <el-input v-model.number="form.operaInCabPic"
                                            placeholder="请输入菜品名称拼音"></el-input>
                                    </el-form-item>
                                </el-col>

                            </el-row>
                        </div>
                    </el-form>
                </el-tab-pane>
                <!-- 新增菜品时的用料标签页 -->
                <el-tab-pane label="用料清单" name="ingredients" :z-index="2000">
                    <div class="ingredients-container">
                        <div class="ingredients-header"
                            style="margin-bottom: 20px; display: flex; justify-content: space-between; align-items: center;">
                            <h3 class="ingredients-title">菜品用料明细</h3>
                        </div>

                        <!-- 用料表格（支持单元格内直接编辑） -->
                        <el-table :data="addForm.dishes" border class="ingredients-table" style="width: 100%"
                            :empty-text="addForm.dishes.length === 0 ? '暂无用料记录，请点击新增' : '加载中...'">
                            <!-- 食材名称（下拉选择框） -->
                            <el-table-column label="食材名称" width="160" align="center">
                                <template #default="scope">
                                    <el-select v-model="scope.row.ingredientName" placeholder="选择食材名称" size="mini"
                                        @change="handleIngredientChange(scope.row, $event)" filterable clearable>
                                        <el-option v-for="option in ingredientOptions" :key="option.value"
                                            :label="option.label" :value="option.value"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <!-- 用量（数字输入，直接编辑） -->
                            <el-table-column label="用量" width="100" align="center">
                                <template #default="scope">
                                    <el-input v-model.number="scope.row.num" placeholder="0" size="mini" type="number"
                                        min="0.1" step="0.1">
                                    </el-input>
                                </template>
                            </el-table-column>
                            <!-- 单位（直接编辑） -->
                            <el-table-column label="单位" width="80" align="center">
                                <template #default="scope">
                                    <el-input v-model="scope.row.unit" placeholder="如g" size="mini">
                                    </el-input>
                                </template>
                            </el-table-column>
                            <!-- 备注（直接编辑） -->
                            <el-table-column label="备注">
                                <template #default="scope">
                                    <el-input v-model="scope.row.remark" placeholder="可选备注" size="mini">
                                    </el-input>
                                </template>
                            </el-table-column>
                            <!-- 操作（删除按钮，与添加步骤的删除逻辑一致） -->
                            <el-table-column label="操作" width="120" align="center">
                                <template #default="scope">
                                    <el-button size="mini" type="text" style="color: #F56C6C;"
                                        @click="handleDeleteIngredient1(scope.$index)">
                                        删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>

                        <!-- 添加用料按钮（与添加步骤按钮风格完全一致） -->
                        <div style="margin-top: 10px;">
                            <el-button type="primary" @click="handleAddIngredient('common')">+ 添加用料</el-button>
                        </div>
                    </div>
                </el-tab-pane> <!-- 新增菜品时的营养成分标签页 -->
                <el-tab-pane label="营养成分" name="nutrition">
                    <div class="nutrition-container">
                        <div class="nutrition-header"
                            style="margin-bottom: 20px; display: flex; justify-content: space-between; align-items: center;">
                            <div>
                                <h3 class="nutrition-title">营养成分设置</h3>
                                <p class="nutrition-desc">设置菜品的营养成分信息</p>
                            </div>
                            <!-- 修改：添加按钮，点击直接增加一行 -->
                            <el-button type="primary" size="small" @click="handleAddNutrition">+ 添加营养成分</el-button>
                        </div>

                        <!-- 营养成分表格（改为直接编辑模式） -->
                        <el-table :data="addForm.nutrition" border style="width: 100%"
                            :empty-text="addForm.nutrition.length === 0 ? '暂无营养成分数据，请点击新增' : '加载中...'">
                            <el-table-column label="营养素" width="180" align="center">
                                <template #default="scope">
                                    <el-input v-model="scope.row.nutritionName" placeholder="输入营养素名称" size="mini"
                                        @blur="handleNutritionBlur(scope.row)">
                                    </el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="含量" width="120" align="center">
                                <template #default="scope">
                                    <el-input v-model.number="scope.row.num" placeholder="0" size="mini" type="number"
                                        min="0.1" step="0.1" @blur="handleNutritionBlur(scope.row)">
                                    </el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="单位" width="80" align="center">
                                <template #default="scope">
                                    <el-input v-model="scope.row.unit" placeholder="如g" size="mini"
                                        @blur="handleNutritionBlur(scope.row)">
                                    </el-input>
                                </template>
                            </el-table-column>
                            <!-- 修改：增加删除操作列 -->
                            <el-table-column label="操作" width="120" align="center">
                                <template #default="scope">
                                    <el-button size="mini" type="text" style="color: #F56C6C;"
                                        @click="handleDeleteNutrition(scope.$index)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-tab-pane>

            </el-tabs>

            <div slot="footer" class="dialog-footer">
                <el-button @click="addModalVisible = false">取消</el-button>
                <el-button type="primary" @click="submitAddForm()">确定</el-button>
            </div>
        </el-dialog>

        <!-- 3. 菜品详情抽屉（右侧滑出 + Tab切换：基础信息/介绍/用料/营养分析） -->
        <el-drawer title="菜品详情" :visible.sync="detailDrawerVisible" placement="right" size="60%"
            :close-on-click-modal="false" :append-to-body="true" custom-class="detail-drawer" :z-index="1000">
            <!-- Tab切换导航 - 新增"菜品介绍"标签页 -->
            <el-tabs v-model="activeTab" class="detail-tabs" :stretch="true" ref="tabs" @tab-click="handleTabClick">
                <!-- 3.1 基础信息Tab -->
                <el-tab-pane label="基础信息" name="basic">
                    <div class="detail-container">
                        <!-- 详情头部：菜品名称 + 状态标签 -->
                        <div class="detail-header">
                            <h2 class="dish-name">{{ currentDish.dishName }}</h2>
                            <el-tag :type="currentDish.status === '在售' ? 'success' : 'warning'" size="small">
                                {{ currentDish.status || '未上架' }}
                            </el-tag>
                        </div>

                        <!-- 菜品大图预览 -->
                        <div class="detail-image">
                            <img :src="currentDish.coverImg" :alt="currentDish.dishName + '大图'" class="dish-big-photo">
                        </div>

                        <!-- 菜品详情表格 -->
                        <el-table :data="detailTableData" border :show-header="false" class="detail-table"
                            style="margin-top: 20px;">
                            <el-table-column prop="label" width="120" align="center">
                                <template #default="scope">{{ scope.row.label }}</template>
                            </el-table-column>
                            <el-table-column prop="value" align="left">
                                <template #default="scope">{{ scope.row.value || '暂无数据' }}</template>
                            </el-table-column>
                        </el-table>

                        <!-- 底部操作按钮 -->
                        <div class="detail-actions" style="margin-top: 30px; text-align: right;">
                            <el-button @click="detailDrawerVisible = false">关闭</el-button>
                            <el-button type="primary" @click="goToEdit(currentDish)">编辑</el-button>
                        </div>
                    </div>
                </el-tab-pane>

                <!-- 3.2 菜品介绍Tab - 新增标签页 -->
                <el-tab-pane label="菜品介绍" name="introduction">
                    <div class="introduction-container">
                        <div class="introduction-content">
                            <h3 class="introduction-title">菜品详情介绍</h3>
                            <div class="introduction-text">
                                <p v-if="currentDish.introduction">{{ currentDish.introduction }}</p>
                                <p v-else class="no-introduction">暂无该菜品的详细介绍信息</p>
                            </div>

                            <!-- 菜品特点标签 -->
                            <div v-if="currentDish.features && currentDish.features.length > 0"
                                class="features-container">
                                <h4 class="features-title">菜品特点</h4>
                                <div class="features-tags">
                                    <el-tag v-for="(feature, index) in currentDish.features" :key="index" type="info"
                                        style="margin-right: 8px; margin-bottom: 8px;">
                                        {{ feature }}
                                    </el-tag>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>

                <!-- 3.3 用料Tab -->
                <el-tab-pane label="用料清单" name="ingredients">
                    <div class="ingredients-container">
                        <!-- 新增用料按钮 -->
                        <div class="ingredients-header"
                            style="margin-bottom: 20px; display: flex; justify-content: space-between; align-items: center;">
                            <h3 class="ingredients-title">菜品用料明细</h3>
                            <el-button type="primary" size="small" @click="openIngredientsModal()">新增用料</el-button>
                        </div>

                        <!-- 用料表格 -->
                        <el-table :data="currentDish.dishes" border class="ingredients-table" style="width: 100%"
                            :empty-text="currentDish.dishes.length === 0 ? '暂无用料记录' : '加载中...'">
                            <el-table-column label="食材名称" prop="ingredientName" width="160"
                                align="center"></el-table-column>

                            <el-table-column label="用量" prop="num" width="100" align="center"></el-table-column>
                            <el-table-column label="单位" prop="unit" width="80" align="center"></el-table-column>
                            <el-table-column label="备注" prop="remark"></el-table-column>
                            <el-table-column label="操作" width="120" align="center">
                                <template #default="scope">
                                    <el-button size="mini" type="text" @click="editIngredient(scope.row)">编辑</el-button>
                                    <el-button size="mini" type="text" @click="deleteIngredient(scope.row)"
                                        style="color: #F56C6C;">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-tab-pane>

                <!-- 3.4 营养分析Tab -->
                <el-tab-pane label="营养分析" name="nutrition">
                    <div class="nutrition-container">
                        <div class="nutrition-header"
                            style="margin-bottom: 20px; display: flex; justify-content: space-between; align-items: center;">
                            <div>
                                <h3 class="nutrition-title">营养成分分析</h3>
                                <p class="nutrition-desc">基于菜品用料计算的营养成分表（每份）</p>
                            </div>
                            <!-- 修改：统一调用 openAddNutritionModal 方法 -->
                            <el-button type="primary" size="small" @click="openAddNutritionModal()">新增营养成分</el-button>
                        </div>

                        <!-- 营养分析概览卡片 -->
                        <el-row :gutter="15" style="margin-bottom: 20px;">
                            <el-col :span="6">
                                <el-card class="nutrition-card">
                                    <div slot="header" class="nutrition-card-header">总热量</div>
                                    <div class="nutrition-card-value">{{ totalNutrition.calorie.toFixed(1) }} kcal
                                    </div>
                                    <div class="nutrition-card-desc">每日参考值约2000kcal</div>
                                </el-card>
                            </el-col>
                            <el-col :span="6">
                                <el-card class="nutrition-card">
                                    <div slot="header" class="nutrition-card-header">蛋白质</div>
                                    <div class="nutrition-card-value">{{ totalNutrition.protein.toFixed(1) }} g</div>
                                    <div class="nutrition-card-desc">每日参考值约60g</div>
                                </el-card>
                            </el-col>
                            <el-col :span="6">
                                <el-card class="nutrition-card">
                                    <div slot="header" class="nutrition-card-header">脂肪</div>
                                    <div class="nutrition-card-value">{{ totalNutrition.fat.toFixed(1) }} g</div>
                                    <div class="nutrition-card-desc">每日参考值约65g</div>
                                </el-card>
                            </el-col>
                            <el-col :span="6">
                                <el-card class="nutrition-card">
                                    <div slot="header" class="nutrition-card-header">碳水化合物</div>
                                    <div class="nutrition-card-value">{{ totalNutrition.carbs.toFixed(1) }} g</div>
                                    <div class="nutrition-card-desc">每日参考值约300g</div>
                                </el-card>
                            </el-col>
                        </el-row>

                        <!-- 详细营养成分表 -->
                        <el-card style="margin-top: 20px;">
                            <div slot="header">详细营养成分</div>
                            <el-table :data="nutritionTableData" border style="width: 100%"
                                :empty-text="nutritionTableData.length === 0 ? '暂无营养成分数据' : '加载中...'">
                                <el-table-column label="营养素" prop="nutritionName" width="180"></el-table-column>
                                <el-table-column label="含量" prop="num"></el-table-column>

                                <el-table-column label="操作" width="120" align="center"
                                    v-if="currentDish.nutrition && currentDish.nutrition.length > 0">
                                    <template #default="scope">
                                        <el-button size="mini" type="text"
                                            @click="editNutrition(scope.row)">编辑</el-button>
                                        <el-button size="mini" type="text" @click="deleteNutrition(scope.row)"
                                            style="color: #F56C6C;">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-card>

                        <!-- 营养图表容器 -->
                        <div class="chart-container" style="display: flex; gap: 20px; margin-top: 20px;">
                            <div style="flex: 1; height: 250px;">
                                <canvas id="macroNutrientChart"></canvas>
                            </div>
                            <div style="flex: 1; height: 250px;">
                                <canvas id="calorieSourceChart"></canvas>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </el-drawer>

        <!-- 4. 新增/编辑用料弹窗 -->
        <el-dialog title="菜品用料" :visible.sync="ingredientsModalVisible" width="500px" :close-on-click-modal="false"
            custom-class="ingredients-modal" :z-index="9000" append-to-body modal-append-to-body>
            <el-form ref="ingredientsForm" :model="ingredientsForm" :rules="ingredientsRules" label-width="120px"
                class="ingredients-form">
                <el-form-item label="食材名称" prop="ingredientName">
                    <el-select v-model="ingredientsForm.ingredientName" placeholder="选择食材名称" style="width: 75%"
                        filterable clearable @change="handleIngredientModalChange($event)">
                        <el-option v-for="option in ingredientOptions" :key="option.value" :label="option.label"
                            :value="option.value"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="用量" prop="num">
                    <el-input v-model.number="ingredientsForm.num" placeholder="输入用量" style="width: 75%"></el-input>
                </el-form-item>
                <el-form-item label="单位" prop="unit">
                    <el-input v-model="ingredientsForm.unit" placeholder="输入单位" style="width: 75%"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="ingredientsForm.remark" placeholder="输入备注信息" style="width: 75%"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="ingredientsModalVisible = false">取消</el-button>
                <el-button type="primary" @click="submitIngredients()">确定</el-button>
            </div>
        </el-dialog>

        <!-- 5. 新增/编辑步骤弹窗 -->
        <el-dialog title="制作步骤" :visible.sync="stepModalVisible" width="500px" :close-on-click-modal="false"
            custom-class="step-modal">
            <el-form ref="stepForm" :model="stepForm" :rules="stepRules" label-width="120px" class="step-form">
                <el-form-item label="步骤描述" prop="introduction">
                    <el-input v-model="stepForm.introduction" type="textarea" rows="3" placeholder="输入步骤描述"
                        style="width: 75%"></el-input>
                </el-form-item>
                <el-form-item label="步骤图片">
                    <el-upload class="upload-demo" action="#" :auto-upload="false" :on-change="handleStepImageChange"
                        :file-list="stepFileList" list-type="picture-preview">
                        <el-button size="small" type="primary">选择图片</el-button>
                        <div slot="tip" class="el-upload__tip">支持JPG/PNG格式，大小不超过200k</div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="stepModalVisible = false">取消</el-button>
                <el-button type="primary" @click="submitStep()">确定</el-button>
            </div>
        </el-dialog>

        <!-- 6. 新增/编辑营养成分弹窗（详情页用） -->
        <el-dialog title="营养成分" :visible.sync="nutritionModalVisible" width="500px" :close-on-click-modal="false"
            custom-class="nutrition-modal" :append-to-body="true">
            <el-form ref="nutritionForm" :model="nutritionForm" :rules="nutritionRules" label-width="120px"
                class="nutrition-form">
                <el-form-item label="营养素名称" prop="nutritionName">
                    <el-input v-model="nutritionForm.nutritionName" placeholder="输入营养素名称（如：维生素C）"
                        style="width: 75%"></el-input>
                </el-form-item>
                <el-form-item label="含量" prop="num">
                    <el-input v-model.number="nutritionForm.num" placeholder="输入含量（如：60）" style="width: 75%"></el-input>
                </el-form-item>
                <el-form-item label="单位" prop="unit">
                    <el-input v-model="nutritionForm.unit" placeholder="输入单位（如：mg）" style="width: 75%"></el-input>
                </el-form-item>
                <el-form-item label="每日参考值%" prop="dv">
                    <el-input v-model.number="nutritionForm.dv" placeholder="输入每日参考值百分比（如：40）"
                        style="width: 75%"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="nutritionModalVisible = false">取消</el-button>
                <el-button type="primary" @click="submitNutrition()">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getRoomList } from "@/api/function";
import Chart from 'chart.js/auto';
import { getDishList, add, del, edit } from "@/api/dish";
import { getAllProducts } from "@/api/ingredients";
import {
    getDeviceTypeList
} from "@/api/device";
export default {
    name: 'DishView',
    data() {
        return {
            dialogTitle: '新增菜品',
            roomList: [],
            INGREDIENT_TYPES: {
                VEGETABLE: 'vegetable',
                MEAT: 'meat',
                SEASONING: 'seasoning',
                OTHER: 'other'
            },
            formInline: { dishName: '', dishType: '' },
            cookDeviceList: [

            ],
            examples: [],
            ingredientOptions: [],
            nutritionDatabase: {
            },
            dailyReferenceIntake: { calorie: 2000, protein: 60, fat: 65, carbs: 300, fiber: 25, cholesterol: 300, calcium: 1000, iron: 18, sodium: 2300 },
            totalNutrition: { calorie: 0, protein: 0, fat: 0, carbs: 0, fiber: 0, cholesterol: 0, calcium: 0, iron: 0, sodium: 0 },
            nutritionTableData: [],
            STEP_TYPES: {
                POT: "1",
                SEASONING: "2",
                SOLID_BOX: "3",
                STEAMER: "4" // 新增：蒸柜步骤类型
            },
            form: {
                id: "",
                nutritionName: "", introduction: '',
                cuisine: "",
                equipmentType: "",
                dishWeight: "",
                dishCount: "",
                isCommon: 0,
                duringTime: "",
                imageName: "",
                stepBeans: [],// 👇 添加以下字段
                minute: "",       // 炒菜总需时间
                temperature: "",  // 温度
                operaInCabPic: "",
            },
            formRules: {
                cuisine: [{ required: true, message: "请输入菜系", trigger: "blur" }],
                equipmentType: [{ required: true, message: "请选择设备类型", trigger: "change" }],
                dishWeight: [
                    { required: true, message: "请输入单重量", trigger: "blur" },
                    { type: "number", message: "单重量必须为数字", trigger: "blur" },
                ],
                dishCount: [
                    { required: true, message: "请输入份数", trigger: "blur" },
                    { type: "number", message: "份数必须为数字", trigger: "blur" },
                ],
                duringTime: [
                    { required: true, message: "请输入炒菜总需时间", trigger: "blur" },
                    { type: "number", message: "炒菜总需时间必须为数字", trigger: "blur" },
                ],
                imageName: [{ required: true, message: "请输入图片名称", trigger: "blur" }],
                minute: [
                    { required: true, message: "请输入炒菜总需时间", trigger: "blur" },
                    { type: "number", message: "炒菜总需时间必须为数字", trigger: "blur" },
                ],
                temperature: [
                    { required: true, message: "请输入温度", trigger: "blur" },
                    { type: "number", message: "温度必须为数字", trigger: "blur" },
                ],

            }, priceSort: '',
            currentPage: 1,
            pageSize: 10,
            ingredientsModalVisible: false,
            stepModalVisible: false,
            nutritionModalVisible: false,
            addModalVisible: false,
            detailDrawerVisible: false,
            activeTab: 'basic',
            addActiveTab: 'baseInfo',
            currentDish: {
                dishes: [],
                cookingstepBeans: [],
                nutrition: [],
                features: []
            },
            isEditIngredient: false,
            currentIngredient: {},
            currentIngredientIndex: -1,
            isEditStep: false,
            currentStepIndex: -1,
            isEditing: false, // 新增/编辑状态标记
            addForm: {
                dishName: '',
                dishCode: '',
                room: '', category: '',
                dishType: '成品菜',
                price: 0,
                calorie: 0,
                cookTime: 0,
                image: '',
                introduction: '',
                features: [],
                nutrition: [],
                dishes: [],
                cookingEquipment: []
            },
            ingredientsForm: { ingredientName: '', spec: '', num: 0, unit: '', remark: '' },
            stepForm: { introduction: '', image: '' },
            nutritionForm: { nutritionName: '', num: 0, unit: '', dv: 0 },
            addFileList: [],
            editFileList: [],
            stepFileList: [],
            dishRules: {
                dishName: [{ required: true, message: '请输入菜品名称', trigger: 'blur' }, { min: 1, max: 20, message: '长度在1-20个字符之间', trigger: 'blur' }],
                dishCode: [{ required: true, message: '请输入菜品编号', trigger: 'blur' }, { min: 3, max: 20, message: '长度在3-20个字符之间', trigger: 'blur' }],
                price: [{ required: true, message: '请输入菜品价格', trigger: 'blur' }, { type: 'number', min: 0.01, message: '价格必须大于0', trigger: 'blur' }],
                cookingEquipment: [
                    {
                        required: true,
                        message: '请选择至少一种烹饪设备',
                        trigger: 'change',
                        type: 'array',
                        min: 1
                    }
                ]
            },
            ingredientsRules: {
                ingredientName: [{ required: true, message: '请选择食材名称', trigger: 'change' }],
                num: [{ required: true, message: '请输入用量', trigger: 'blur' }, { type: 'number', min: 0.1, message: '用量必须大于0', trigger: 'blur' }],
                unit: [{ required: true, message: '请输入单位', trigger: 'blur' }]
            },
            stepRules: {
                introduction: [{ required: true, message: '请输入步骤描述', trigger: 'blur' }, { min: 5, max: 200, message: '长度在5-200个字符之间', trigger: 'blur' }]
            },
            nutritionRules: {
                nutritionName: [{ required: true, message: '请输入营养素名称', trigger: 'blur' }, { min: 1, max: 30, message: '长度在1-30个字符之间', trigger: 'blur' }],
                num: [{ required: true, message: '请输入含量', trigger: 'blur' }, { type: 'number', min: 0.01, message: '含量必须大于0', trigger: 'blur' }],
                unit: [{ required: true, message: '请输入单位', trigger: 'blur' }, { min: 1, max: 10, message: '单位长度在1-10个字符之间', trigger: 'blur' }],
            },
            detailTableData: [],
            macroChart: null,
            calorieChart: null,
            timeRules: [{ required: true, message: '请输入时间', trigger: 'blur' }, { type: 'number', message: '时间必须为数字', trigger: 'blur' }],
            firepowerRules: [{ required: true, message: '请输入火力值', trigger: 'blur' }, { type: 'number', message: '火力值必须为数字', trigger: 'blur' }],
            speedRules: [{ required: true, message: '请选择速度', trigger: 'change' }],
            liftDownRules: [{ required: true, message: '请选择抬起/放下', trigger: 'change' }],
            temperatureRules: [{ required: true, message: '请输入温度', trigger: 'blur' }, { type: 'number', message: '温度必须为数字', trigger: 'blur' }],
            coefficientRules: [{ required: true, message: '请输入系数', trigger: 'blur' }, { type: 'number', message: '系数必须为数字', trigger: 'blur' }]
        }
    },
    computed: {
        filteredData() {
            let result = this.examples.filter(item => {
                const matchName = item.dishName.toLowerCase().includes(this.formInline.dishName.toLowerCase());
                const matchdishType = this.formInline.dishType ? item.dishType === this.formInline.dishType : true;
                return matchName && matchdishType;
            });

            if (this.priceSort === 'asc') {
                result = [...result].sort((a, b) => a.price - b.price);
            } else if (this.priceSort === 'desc') {
                result = [...result].sort((a, b) => b.price - a.price);
            }

            return result;
        },
        filteredExamples() {
            return this.filteredData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
        },
        total() {
            return this.filteredData.length;
        },
        // 👇 新增计算属性：判断是否选择了包含"炒菜机"的设备
        hasCookerMachine() {
            // 判断烹饪设备数组中是否有包含"炒菜机"的选项
            if (!this.addForm.cookingEquipment || this.addForm.cookingEquipment.length === 0) {
                return false;
            }
            // 遍历选中的设备，检查是否包含"炒菜机"关键词
            return this.addForm.cookingEquipment.some(device =>
                device && device.includes('炒菜机')
            );
        },
        // 👇 修改为检测蒸柜关键词
        hasSteamerCabinet() {
            // 判断烹饪设备数组中是否有包含"蒸柜"的选项
            if (!this.addForm.cookingEquipment || this.addForm.cookingEquipment.length === 0) {
                return false;
            }
            // 遍历选中的设备，检查是否包含"蒸柜"关键词
            return this.addForm.cookingEquipment.some(device =>
                device && device.includes('蒸柜')
            );
        }
    },
    mounted() {
        this.resetSearch();
        this.loadRoomList();
    },
    created() {
        this.getList();
        this.getType()
    },
    methods: {

        // 请求设备类型
        getType() {
            getDeviceTypeList({ userId: localStorage.getItem('userId') })
                .then(response => {
                    console.log('设备类型接口返回数据：', response);
                    // 将原始数据转换为 Select 组件需要的格式
                    if (response && response.data && Array.isArray(response.data)) {
                        this.cookDeviceList = response.data.map(device => {
                            // 转换格式：label 显示设备名称，value 也使用设备名称（也可以用 id）
                            return {
                                label: device.typeName || '未知设备',
                                value: device.typeName || device.id // 优先用名称，备用用ID
                            };
                        });
                    } else {
                        // 接口返回格式异常时使用默认数据兜底
                        this.cookDeviceList = [

                        ];
                        console.warn('设备类型接口返回数据格式异常，使用默认数据');
                    }
                })
                .catch(error => {
                    // 请求失败时使用默认数据兜底
                    console.error('获取设备类型失败：', error);
                    this.$message.error('加载设备类型失败，使用默认设备列表');

                });
        },
        async loadRoomList() {
            try {
                const res = await getRoomList({ userId: localStorage.getItem('userId') });
                this.roomList = res.data || [];
            } catch (error) {
                this.$message.error('加载功能间列表失败');
                console.error('功能间加载失败：', error);
            }
        },

        getLists() {
            getAllProducts({ userId: localStorage.getItem('userId') }).then(response => {
                const uniqueIngredients = {};
                (response.data || []).forEach(item => {
                    if (item.pname && !uniqueIngredients[item.pname]) {
                        uniqueIngredients[item.pname] = {
                            label: item.pname,
                            value: item.pname,
                            unit: item.punit || ''
                        };
                    }
                });
                this.ingredientOptions = Object.values(uniqueIngredients);
            }).catch(error => {
                console.error('获取食材列表失败:', error);
                this.$message.error('获取食材列表失败，请重试');
            });
        },

        handleIngredientChange(row, selectedValue) {
            const selectedOption = this.ingredientOptions.find(
                option => option.value === selectedValue
            );
            if (selectedOption) {
                this.$set(row, 'unit', selectedOption.unit);
            } else {
                this.$set(row, 'unit', '');
            }
        },

        handleIngredientModalChange(selectedValue) {
            const selectedOption = this.ingredientOptions.find(
                option => option.value === selectedValue
            );
            if (selectedOption) {
                this.ingredientsForm.unit = selectedOption.unit;
            } else {
                this.ingredientsForm.unit = '';
            }
        },

        handleNutritionBlur(row) {
            if (!row.nutritionName) {
                this.$message.warning('请输入营养素名称');
            }
        },

        getList() {
            getDishList({ userId: localStorage.getItem('userId'), type: '成品菜' }).then(response => {
                const rawData = response.data || [];
                this.examples = rawData.map(item => ({
                    ...item,
                    price: Number(item.price) || 0,
                    coverImg: item.coverImg,
                }));
            }).catch(error => {
                console.error("获取菜品列表失败:", error);
                this.$message.error("获取菜品列表失败，请刷新页面");
            });
        },

        handleAddIngredient(ingredientType) {
            const newIngredient = {
                type: ingredientType,
                ingredientName: '',
                num: 0,
                unit: '',
                remark: ''
            };
            if (!this.addForm.dishes) {
                this.addForm.dishes = [];
            }
            this.addForm.dishes.push(newIngredient);
        },

        handleDeleteIngredient1(index) {
            this.addForm.dishes.splice(index, 1);
            this.$message.success('用料删除成功');
        },

        // 新增：直接添加营养成分行的方法
        handleAddNutrition() {
            const newNutrition = {
                nutritionName: '',
                num: 0,
                unit: '',
                dv: 0
            };
            if (!this.addForm.nutrition) {
                this.addForm.nutrition = [];
            }
            this.addForm.nutrition.push(newNutrition);
        },

        // 新增：删除营养成分行的方法
        handleDeleteNutrition(index) {
            this.addForm.nutrition.splice(index, 1);
            this.$message.success('营养成分删除成功');
        },

        handleTabClick(tab) {
            if (tab.name === 'nutrition') {
                this.$nextTick(() => {
                    this.initNutritionCharts();
                });
            }
        },

        resetSearch() {
            this.currentPage = 1;
            this.formInline = { dishName: '', dishType: '' };
            this.priceSort = '';
        },

        onSubmit() {
            this.currentPage = 1;
        },

        openAddModal() {
            this.addModalVisible = true;
            this.getLists();
            this.dialogTitle = '新增菜品';
            this.addActiveTab = 'baseInfo';
            this.isEditing = false;
            this.$nextTick(() => {
                this.$refs.addForm?.resetFields();
                this.addFileList = [];
                this.addForm = {
                    dishName: '',
                    dishCode: '', category: '',
                    room: '',
                    dishType: '成品菜',
                    price: 0,
                    calorie: 0,
                    cookTime: 0,
                    image: '',
                    introduction: '',
                    features: [],
                    nutrition: [],
                    dishes: [],
                    cookingEquipment: []
                };
                this.form = {
                    id: "",
                    name: "",
                    cuisine: "",
                    equipmentType: "",
                    dishWeight: "",
                    dishCount: "",
                    isCommon: 0,
                    duringTime: "",
                    imageName: "",
                    stepBeans: [],
                    introduction: '',// 👇 重置新增字段
                    minute: "",
                    temperature: "",
                    operaInCabPic: ""

                };
            });
        },

        openEditModal(item) {
            this.addModalVisible = true;
            this.dialogTitle = '修改菜品';
            this.addActiveTab = 'baseInfo';
            this.isEditing = true;
            this.getLists();

            this.addForm = { ...item };
            this.form.stepBeans = JSON.parse(item.stepBeansString || '[]');
            this.addForm.nutrition = JSON.parse(item.nutritionString || '[]');
            this.addForm.dishes = JSON.parse(item.dishesString || '[]');
            this.addForm.cookingEquipment = JSON.parse(item.deviceString || '[]');
            this.form.duringTime = item.duringTime;
            this.form.dishCount = item.dishCode;
            this.form.dishWeight = item.dishWeight;
            this.form.category = item.category
            this.editFileList = [];
            if (this.addForm.image) {
                this.editFileList.push({
                    name: '菜品图片',
                    url: this.addForm.image
                });
            }

            // 回显蒸柜相关字段
            const steamerStep = this.form.stepBeans.find(step => step.type === this.STEP_TYPES.STEAMER);
            if (steamerStep) {
                this.form.minute = steamerStep.minute;
                this.form.temperature = steamerStep.temperature;
                this.form.operaInCabPic = steamerStep.operaInCabPic
            }
        },

        openDetailDrawer(item) {
            this.currentDish = {
                ...item,
                dishes: JSON.parse(item.dishesString || '[]'),
                cookingstepBeans: item.cookingstepBeans || [],
                nutrition: JSON.parse(item.nutritionString || '[]'),
                introduction: item.introduction || '',
                features: item.features || []
            };
            this.detailDrawerVisible = true;

            this.detailTableData = [
                { label: '菜品名称', value: item.dishName },
                { label: '菜品编号', value: item.dishCode },
                { label: '价格', value: `¥${item.price.toFixed(2)}` },
                { label: '热量', value: `${item.calorie || '未知'}kcal` },
                { label: '烹饪时间', value: `${item.duringTime || '未知'}分钟` },
            ];

            this.calculateNutrition();
            this.$nextTick(() => {
                if (this.activeTab === 'nutrition') {
                    this.initNutritionCharts();
                }
            });
        },

        calculateNutrition() {
            if (!this.currentDish.nutrition) {
                this.currentDish.nutrition = [];
            }

            if (this.currentDish.nutrition.length > 0) {
                this.nutritionTableData = this.currentDish.nutrition.map(item => ({
                    nutritionName: item.nutritionName,
                    num: `${item.num.toFixed(1)} ${item.unit}`,
                    dv: item.dv
                }));
                const calorieItem = this.currentDish.nutrition.find(item => item.nutritionName.includes('热量'));
                const proteinItem = this.currentDish.nutrition.find(item => item.nutritionName.includes('蛋白质'));
                const fatItem = this.currentDish.nutrition.find(item => item.nutritionName.includes('脂肪'));
                const carbsItem = this.currentDish.nutrition.find(item => item.nutritionName.includes('碳水'));
                this.totalNutrition = {
                    calorie: calorieItem ? calorieItem.num : 0,
                    protein: proteinItem ? proteinItem.num : 0,
                    fat: fatItem ? fatItem.num : 0,
                    carbs: carbsItem ? carbsItem.num : 0,
                    fiber: 0, cholesterol: 0, calcium: 0, iron: 0, sodium: 0
                };
            } else {
                this.totalNutrition = { calorie: 0, protein: 0, fat: 0, carbs: 0, fiber: 0, cholesterol: 0, calcium: 0, iron: 0, sodium: 0 };
                (this.currentDish.dishes || []).forEach(ingredient => {
                    const nutrient = this.nutritionDatabase[ingredient.ingredientName];
                    if (nutrient) {
                        const num = parseFloat(ingredient.num) || 0;
                        const ratio = num / 100;
                        this.totalNutrition.calorie += nutrient.calorie * ratio;
                        this.totalNutrition.protein += nutrient.protein * ratio;
                        this.totalNutrition.fat += nutrient.fat * ratio;
                        this.totalNutrition.carbs += nutrient.carbs * ratio;
                        this.totalNutrition.fiber += nutrient.fiber * ratio;
                        this.totalNutrition.cholesterol += nutrient.cholesterol * ratio;
                        this.totalNutrition.calcium += nutrient.calcium * ratio;
                        this.totalNutrition.iron += nutrient.iron * ratio;
                        this.totalNutrition.sodium += nutrient.sodium * ratio;
                    }
                });
                this.generateNutritionTable();
            }
        },

        generateNutritionTable() {
            this.nutritionTableData = [
                { nutritionName: '热量', num: `${this.totalNutrition.calorie.toFixed(1)} kcal`, dv: (this.totalNutrition.calorie / this.dailyReferenceIntake.calorie * 100).toFixed(0) },
                { nutritionName: '蛋白质', num: `${this.totalNutrition.protein.toFixed(1)} g`, dv: (this.totalNutrition.protein / this.dailyReferenceIntake.protein * 100).toFixed(0) },
                { nutritionName: '脂肪', num: `${this.totalNutrition.fat.toFixed(1)} g`, dv: (this.totalNutrition.fat / this.dailyReferenceIntake.fat * 100).toFixed(0) },
                { nutritionName: '碳水化合物', num: `${this.totalNutrition.carbs.toFixed(1)} g`, dv: (this.totalNutrition.carbs / this.dailyReferenceIntake.carbs * 100).toFixed(0) },
                { nutritionName: '膳食纤维', num: `${this.totalNutrition.fiber.toFixed(1)} g`, dv: (this.totalNutrition.fiber / this.dailyReferenceIntake.fiber * 100).toFixed(0) },
                { nutritionName: '胆固醇', num: `${this.totalNutrition.cholesterol.toFixed(1)} mg`, dv: (this.totalNutrition.cholesterol / this.dailyReferenceIntake.cholesterol * 100).toFixed(0) },
                { nutritionName: '钙', num: `${this.totalNutrition.calcium.toFixed(1)} mg`, dv: (this.totalNutrition.calcium / this.dailyReferenceIntake.calcium * 100).toFixed(0) },
                { nutritionName: '铁', num: `${this.totalNutrition.iron.toFixed(1)} mg`, dv: (this.totalNutrition.iron / this.dailyReferenceIntake.iron * 100).toFixed(0) },
                { nutritionName: '钠', num: `${this.totalNutrition.sodium.toFixed(1)} mg`, dv: (this.totalNutrition.sodium / this.dailyReferenceIntake.sodium * 100).toFixed(0) }
            ];
        },

        initNutritionCharts() {
            if (this.macroChart) this.macroChart.destroy();
            if (this.calorieChart) this.calorieChart.destroy();

            const macroCanvas = document.getElementById('macroNutrientChart');
            const calorieCanvas = document.getElementById('calorieSourceChart');

            if (!macroCanvas || !calorieCanvas) {
                console.error('Canvas元素未找到，无法初始化图表');
                return;
            }

            const macroCtx = macroCanvas.getContext('2d');
            const calorieCtx = calorieCanvas.getContext('2d');

            if (!macroCtx || !calorieCtx) {
                console.error('无法获取Canvas上下文，无法初始化图表');
                return;
            }

            this.macroChart = new Chart(macroCtx, {
                type: 'doughnut',
                data: {
                    labels: ['蛋白质', '脂肪', '碳水化合物'],
                    datasets: [{
                        data: [this.totalNutrition.protein, this.totalNutrition.fat, this.totalNutrition.carbs],
                        backgroundColor: ['#409EFF', '#F56C6C', '#67C23A'],
                        borderWidth: 1
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: { position: 'bottom' },
                        tooltip: {
                            callbacks: {
                                label: (context) => {
                                    const label = context.label || '';
                                    const value = context.raw || 0;
                                    const total = context.dataset.data.reduce((a, b) => a + b, 0);
                                    const percentage = total > 0 ? Math.round((value / total) * 100) : 0;
                                    return `${label}: ${value.toFixed(1)}g (${percentage}%)`;
                                }
                            }
                        }
                    }
                }
            });

            const proteinCalorie = this.totalNutrition.protein * 4;
            const fatCalorie = this.totalNutrition.fat * 9;
            const carbsCalorie = this.totalNutrition.carbs * 4;
            this.calorieChart = new Chart(calorieCtx, {
                type: 'pie',
                data: {
                    labels: ['蛋白质', '脂肪', '碳水化合物'],
                    datasets: [{
                        data: [proteinCalorie, fatCalorie, carbsCalorie],
                        backgroundColor: ['#409EFF', '#F56C6C', '#67C23A'],
                        borderWidth: 1
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: { position: 'bottom' },
                        tooltip: {
                            callbacks: {
                                label: (context) => {
                                    const label = context.label || '';
                                    const value = context.raw || 0;
                                    const total = context.dataset.data.reduce((a, b) => a + b, 0);
                                    const percentage = total > 0 ? Math.round((value / total) * 100) : 0;
                                    return `${label}: ${value.toFixed(1)}kcal (${percentage}%)`;
                                }
                            }
                        }
                    }
                }
            });
        },

        goToEdit(item) {
            this.detailDrawerVisible = false;
            this.$nextTick(() => {
                this.openEditModal(item);
            });
        },

        // handleImageChange(file, fileList) {
        //     this.addFileList = fileList;
        //     if (file.raw) {
        //         this.addForm.image = URL.createObjectURL(file.raw);
        //     }
        // },
        // 新增：上传前校验文件大小
        beforeImageUpload(file) {
            // 1. 校验文件类型
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            const isImage = isJPG || isPNG;

            // 2. 校验文件大小 (200KB)
            const isLt200K = file.size / 1024 < 200;

            if (!isImage) {
                this.$message.error('上传图片只能是 JPG/PNG 格式!');
                return false; // 阻止上传
            }

            if (!isLt200K) {
                this.$message.error('上传图片大小不能超过 200KB!');
                return false; // 阻止上传
            }

            return true; // 校验通过
        },

        // 优化：handleImageChange 方法（添加二次校验）
        handleImageChange(file, fileList) {
            // 二次校验，防止绕过 before-upload 的情况
            if (file.raw && file.raw.size / 1024 >= 200) {
                this.$message.error('上传图片大小不能超过 200KB!');
                // 移除不符合要求的文件
                this.addFileList = fileList.filter(item => item.uid !== file.uid);
                return;
            }

            this.addFileList = fileList;
            if (file.raw) {
                this.addForm.image = URL.createObjectURL(file.raw);
            }
        },

        // 优化：handleStepImageChange 方法（添加二次校验）
        handleStepImageChange(file, fileList) {
            // 二次校验，防止绕过 before-upload 的情况
            if (file.raw && file.raw.size / 1024 >= 200) {
                this.$message.error('上传图片大小不能超过 200KB!');
                // 移除不符合要求的文件
                this.stepFileList = fileList.filter(item => item.uid !== file.uid);
                return;
            }

            this.stepFileList = fileList;
            if (file.raw) {
                this.stepForm.image = URL.createObjectURL(file.raw);
            }
        },
        // handleStepImageChange(file, fileList) {
        //     this.stepFileList = fileList;
        //     if (file.raw) {
        //         this.stepForm.image = URL.createObjectURL(file.raw);
        //     }
        // },

        removeBase64Prefix(base64Str) {
            if (!base64Str || typeof base64Str !== 'string') return '';
            const prefixRegex = /^data:image\/\w+;base64,/;
            return base64Str.replace(prefixRegex, '');
        },

        getBase64FromUrl(url) {
            return new Promise((resolve, reject) => {
                const image = new Image();
                image.crossOrigin = 'anonymous';
                image.onload = function () {
                    const canvas = document.createElement('canvas');
                    canvas.width = this.width;
                    canvas.height = this.height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(this, 0, 0);
                    try {
                        const base64String = canvas.toDataURL('image/jpeg', 0.9);
                        const pureBase64 = this.removeBase64Prefix(base64String);
                        resolve(pureBase64);
                    } catch (error) {
                        reject(new Error('Canvas 转换为 Base64 失败'));
                    }
                }.bind(this);

                image.onerror = function () {
                    reject(new Error(`无法加载图片: ${url}`));
                };

                image.src = url;
            });
        },

        getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    const pureBase64 = this.removeBase64Prefix(reader.result);
                    resolve(pureBase64);
                };
                reader.onerror = (error) => reject(error);
            });
        },

        async submitAddForm() {
            try {
                await this.$refs.addForm.validate();
            } catch (error) {
                this.$message.warning('请检查并正确填写表单必填项。');
                return;
            }

            try {
                // 👇 核心新增逻辑：处理蒸柜步骤
                if (this.hasSteamerCabinet) {
                    // 先清除已有的蒸柜步骤，避免重复添加
                    this.form.stepBeans = this.form.stepBeans.filter(step => step.type !== this.STEP_TYPES.STEAMER);
                    // 获取原始时间

                    // 添加新的蒸柜步骤
                    this.form.stepBeans.push({
                        type: this.STEP_TYPES.STEAMER,
                        minute: this.form.minute,
                        temperature: this.form.temperature,
                        operaInCabPic: this.form.operaInCabPic,
                        // 保持与炒菜机步骤格式一致，补充默认值
                        // time: 0,
                        // firepower: -1,
                        // speed: '停止',
                        // liftDown: 'up',
                        // oneseasonMultiple: 0,
                        // doubleseasonMultiple: 0,
                        // tripleseasonMultiple: 0,
                        // ingredients: []
                    });
                }

                const submitData = {
                    id: this.isEditing ? this.addForm.id : null,
                    dishName: this.addForm.dishName,
                    dishCode: this.addForm.dishCode,
                    category: this.addForm.category,
                    room: this.addForm.room,
                    price: this.addForm.price,
                    calorie: this.addForm.calorie,
                    cookTime: this.addForm.cookTime,
                    introduction: this.addForm.introduction,
                    duringTime: this.form.duringTime,
                    stepBeans: this.form.stepBeans,
                    nutrition: this.addForm.nutrition,
                    dishes: this.addForm.dishes,
                    stepBeansString: JSON.stringify(this.form.stepBeans),
                    nutritionString: JSON.stringify(this.addForm.nutrition),
                    dishesString: JSON.stringify(this.addForm.dishes),
                    cookingEquipment: this.addForm.cookingEquipment,
                    deviceString: JSON.stringify(this.addForm.cookingEquipment),
                    userId: localStorage.getItem('userId'),
                    dishType: '成品菜',
                    image: ''
                };

                if (this.addFileList.length > 0 && this.addFileList[0].raw) {
                    submitData.image = await this.getBase64(this.addFileList[0].raw);
                } else if (this.isEditing && this.addForm.image && !this.addForm.image.startsWith('http')) {
                    submitData.image = this.removeBase64Prefix(this.addForm.image);
                }

                let response;
                if (this.isEditing) {
                    response = await edit(submitData);
                } else {
                    response = await add(submitData);
                }

                if (response && response.code === 200) {
                    const actionName = this.isEditing ? '修改' : '新增';
                    this.$message.success(`菜品${actionName}成功！`);
                    this.addModalVisible = false;
                    this.getList();
                } else {
                    const actionName = this.isEditing ? '修改' : '新增';
                    this.$message.error(`${actionName}失败: ${response.message || '未知错误'}`);
                }
            } catch (error) {
                console.error('API 请求失败:', error);
                this.$message.error('网络异常或服务器错误，请稍后重试。');
            }
        },

        deleteDish(item) {
            this.$confirm(`确定要删除 ${item.dishName} 吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const response = await del({ id: item.id, userId: localStorage.getItem('userId') });
                if (response.code === 200) {
                    this.$message.success('删除成功');
                    this.getList();
                } else {
                    this.$message.error(`删除失败：${response.message || "未知错误"}`);
                }
            }).catch(() => {
                this.$message({ type: 'info', message: '已取消删除' });
            });
        },

        openIngredientsModal(row = null) {
            this.ingredientsModalVisible = true;
            this.isAddingDish = false;
            if (row) {
                this.isEditIngredient = true;
                this.currentIngredient = row;
                this.ingredientsForm = { ...row };
            } else {
                this.isEditIngredient = false;
                this.currentIngredient = {};
                this.$nextTick(() => { this.$refs.ingredientsForm?.resetFields(); });
            }
        },

        editIngredient(row) { this.openIngredientsModal(row); },

        deleteIngredient(row) {
            this.$confirm(`确定要删除${row.ingredientName}的记录吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.currentDish.dishes = this.currentDish.dishes.filter(
                    item => !(item.ingredientName === row.ingredientName && item.spec === row.spec)
                );
                this.calculateNutrition();
                this.initNutritionCharts();
                this.$message({ type: 'success', message: '删除用料记录成功!' });
            }).catch(() => {
                this.$message({ type: 'info', message: '已取消删除' });
            });
        },

        submitIngredients() {
            this.$refs.ingredientsForm.validate((isValid) => {
                if (isValid) {
                    const formData = { ...this.ingredientsForm };
                    if (this.isAddingDish) {
                        if (this.isEditIngredient) {
                            const index = this.addForm.dishes.findIndex(
                                item => item.ingredientName === this.currentIngredient.ingredientName && item.spec === this.currentIngredient.spec
                            );
                            if (index !== -1) this.addForm.dishes[index] = formData;
                        } else {
                            if (!this.addForm.dishes) this.addForm.dishes = [];
                            this.addForm.dishes.push(formData);
                        }
                    } else {
                        if (this.isEditIngredient) {
                            const index = this.currentDish.dishes.findIndex(
                                item => item.ingredientName === this.currentIngredient.ingredientName && item.spec === this.currentIngredient.spec
                            );
                            if (index !== -1) this.currentDish.dishes[index] = formData;
                        } else {
                            if (!this.currentDish.dishes) this.currentDish.dishes = [];
                            this.currentDish.dishes.push(formData);
                        }
                        this.calculateNutrition();
                        this.initNutritionCharts();
                    }
                    this.ingredientsModalVisible = false;
                    this.$message.success(`${this.isEditIngredient ? '编辑' : '新增'}用料成功！`);
                }
            });
        },

        handleDeleteIngredient(step, ingredient) {
            step.ingredients = step.ingredients.filter(item => item !== ingredient);
        },

        openStepModal(step = null, index = -1) {
            this.stepModalVisible = true;
            this.stepFileList = [];
            if (step && index !== -1) {
                this.isEditStep = true;
                this.currentStepIndex = index;
                this.stepForm = { ...step };
                if (step.image) this.stepFileList = [{ url: step.image, name: `步骤${index + 1}图片` }];
            } else {
                this.isEditStep = false;
                this.currentStepIndex = -1;
                this.$nextTick(() => {
                    if (this.$refs.stepForm) this.$refs.stepForm.resetFields();
                    this.stepForm = { introduction: '', image: '' };
                });
            }
        },

        editStep(step, index) { this.openStepModal(step, index); },

        deleteStep(index) {
            this.$confirm(`确定要删除步骤${index + 1}吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.currentDish.cookingstepBeans.splice(index, 1);
                this.$message({ type: 'success', message: '删除步骤成功!' });
            }).catch(() => {
                this.$message({ type: 'info', message: '已取消删除' });
            });
        },

        submitStep() {
            this.$refs.stepForm.validate((isValid) => {
                if (isValid) {
                    const formData = { ...this.stepForm };
                    if (!this.currentDish.cookingstepBeans) {
                        this.currentDish.cookingstepBeans = [];
                    }

                    if (this.isEditStep && this.currentStepIndex !== -1) {
                        this.currentDish.cookingstepBeans[this.currentStepIndex] = formData;
                    } else {
                        this.currentDish.cookingstepBeans.push(formData);
                    }
                    this.stepModalVisible = false;
                    this.stepFileList = [];
                    this.$message.success(`${this.isEditStep ? '编辑' : '新增'}步骤成功！`);
                }
            });
        },

        handleAddStep(stepType) {
            const newStep = {
                type: stepType,
                time: 0,
                firepower: -1,
                speed: '停止',
                temperature: '',
                oneseasonMultiple: 0,
                doubleseasonMultiple: 0,
                tripleseasonMultiple: 0,
                liftDown: 'up',
                ingredients: []
            };
            this.form.stepBeans.push(newStep);
        },

        handleDeleteStep(index) {
            this.form.stepBeans.splice(index, 1);
        },

        addNewIngredientRow(step) {
            if (!step.ingredients) {
                step.ingredients = [];
            }
            step.ingredients.push({ id: Date.now(), name: '', weight: 0, num: 0, oneseasonMultiple: 0, doubleseasonMultiple: 0, tripleseasonMultiple: 0 });
        },

        handleSizeChange(val) { this.pageSize = val; this.currentPage = 1; },
        handleCurrentChange(val) { this.currentPage = val; window.scrollTo(0, 300); },

        openNutritionModal(row = null) {
            this.nutritionModalVisible = true;
            this.isAddingDish = false;
            if (row) {
                this.isEditNutrition = true;
                this.currentNutrition = row;
                this.nutritionForm = { ...row };
            } else {
                this.isEditNutrition = false;
                this.currentNutrition = {};
                this.$nextTick(() => {
                    if (this.$refs.nutritionForm) this.$refs.nutritionForm.resetFields();
                });
            }
        },

        editNutrition(row) {
            this.openNutritionModal(row);
        },
        deleteNutrition(row) {
            this.$confirm(`确定要删除${row.nutritionName}的营养成分记录吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.currentDish.nutrition = this.currentDish.nutrition.filter(
                    item => item.nutritionName !== row.nutritionName
                );
                this.calculateNutrition();
                this.initNutritionCharts();
                this.$message({ type: 'success', message: '删除营养成分记录成功!' });
            }).catch(() => {
                this.$message({ type: 'info', message: '已取消删除' });
            });
        },

        submitNutrition() {
            this.$refs.nutritionForm.validate((isValid) => {
                if (isValid) {
                    const formData = { ...this.nutritionForm };
                    if (!this.currentDish.nutrition) {
                        this.currentDish.nutrition = [];
                    }

                    if (this.isEditNutrition) {
                        const index = this.currentDish.nutrition.findIndex(
                            item => item.nutritionName === this.currentNutrition.nutritionName
                        );
                        if (index !== -1) {
                            this.currentDish.nutrition[index] = formData;
                        }
                    } else {
                        this.currentDish.nutrition.push(formData);
                    }
                    this.calculateNutrition();
                    this.initNutritionCharts();
                    this.nutritionModalVisible = false;
                    this.$message.success(`${this.isEditNutrition ? '编辑' : '新增'}营养成分成功！`);
                }
            });
        },

        openAddNutritionModal(row = null) {
            this.nutritionModalVisible = true;
            this.isAddingDish = true;
            if (row) {
                this.isEditNutrition = true;
                this.currentNutrition = row;
                this.nutritionForm = { ...row };
            } else {
                this.isEditNutrition = false;
                this.currentNutrition = {};
                this.$nextTick(() => {
                    if (this.$refs.nutritionForm) this.$refs.nutritionForm.resetFields();
                });
            }
        },

        openAddIngredientsModal(row = null) {
            this.ingredientsModalVisible = true;
            this.isAddingDish = true;
            if (row) {
                this.isEditIngredient = true;
                this.currentIngredient = row;
                this.ingredientsForm = { ...row };
            } else {
                this.isEditIngredient = false;
                this.currentIngredient = {};
                this.$nextTick(() => { if (this.$refs.ingredientsForm) this.$refs.ingredientsForm.resetFields(); });
            }
        },

        deleteAddIngredient(row) {
            this.$confirm(`确定要删除${row.ingredientName}的记录吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.addForm.dishes = this.addForm.dishes.filter(
                    item => !(item.ingredientName === row.ingredientName && item.spec === row.spec)
                );
                this.$message({ type: 'success', message: '删除用料记录成功!' });
            }).catch(() => {
                this.$message({ type: 'info', message: '已取消删除' });
            });
        }
    },
    beforeDestroy() {
        if (this.macroChart) this.macroChart.destroy();
        if (this.calorieChart) this.calorieChart.destroy();
    }
}
</script>

<style lang="scss" scoped>
.page-container {
    height: 100vh;
    display: flex;
    flex-direction: column;
    padding-bottom: 80px;
    box-sizing: border-box;
    background-color: #f5f7fa;
    position: relative;
    z-index: 1;
}

.card-container-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    z-index: 1;
}

.card-container {
    flex: 1;
    margin-top: 20px;
    overflow-y: auto;
    padding: 0 20px 20px;
    max-height: calc(100vh - 30vh);
    height: calc(100vh - 30vh);
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
        display: none;
    }
}

.card-item {
    margin-bottom: 20px;
}

.dish-card {
    height: 100%;
    display: flex;
    flex-direction: column;
    transition: all 0.3s ease;
    background-color: #fff;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08);
    }
}

.card-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 15px;
}

.dish-image {
    width: 100%;
    height: 160px;
    overflow: hidden;
    border-radius: 4px;
    margin-bottom: 15px;
    position: relative;

    .dish-photo {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s ease;

        &:hover {
            transform: scale(1.05);
        }
    }

    .price-tag {
        position: absolute;
        bottom: 10px;
        right: 10px;
        background-color: rgba(255, 69, 0, 0.9);
        color: white;
        padding: 3px 8px;
        border-radius: 4px;
        font-weight: bold;
        font-size: 14px;
    }
}

.dish-info {
    flex: 1;
    font-size: 13px;
    color: #666;
    margin-bottom: 15px;

    .dish-name {
        font-weight: bold;
        color: #333;
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .dish-desc {
        color: #888;
        font-size: 12px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin-top: 8px;
    }

    p {
        margin: 6px 0;
        display: flex;
        align-items: center;

        i {
            margin-right: 5px;
            color: #409EFF;
            width: 18px;
            text-align: center;
        }
    }
}

.card-actions {
    display: flex;
    justify-content: space-between;
    margin-top: auto;
}

.no-data {
    margin: 50px 0;
    text-align: center;
}

.pagination-container {
    padding: 20px 0;
    margin-top: auto;
    background-color: #fff;
    z-index: 2;
    position: fixed;
    width: 100%;
    bottom: 0;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.card-even {
    border-top: 3px solid #409EFF;
}

.card-odd {
    border-top: 3px solid #67C23A;
}

.dish-form {
    margin-top: 15px;

    .el-form-item {
        margin-bottom: 20px;
    }

    .el-upload {
        margin-top: 5px;
    }
}

.dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

::v-deep .dish-modal {
    z-index: 9999 !important;
}

::v-deep .dish-modal+.v-modal {
    z-index: 9998 !important;
}

::v-deep .detail-drawer {
    z-index: 10000 !important;

    .el-drawer__body {
        padding: 0 !important;
    }
}

::v-deep .detail-tabs {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .el-tabs__header {
        margin: 0;
        padding: 15px 20px 0;
        border-bottom: 1px solid #e6e6e6;
    }

    .el-tabs__content {
        flex: 1;
        overflow-y: auto;
        padding: 0 20px;
    }

    .el-tab-pane {
        height: 100%;
        padding: 15px 0;
    }
}

::v-deep .add-dish-tabs {
    width: 100%;
    height: 60vh;
    display: flex;
    flex-direction: column;

    .el-tabs__header {
        margin: 0;
        padding: 0 10px;
    }

    .el-tabs__content {
        flex: 1;
        overflow-y: auto;
        padding: 10px;
    }

    .el-tab-pane {
        height: 100%;
        padding: 5px 0;
    }
}

.detail-container {
    padding: 0;
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;
}

.detail-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.dish-name {
    font-size: 18px;
    font-weight: 700;
    color: #333;
    margin: 0;
}

.detail-image {
    width: 100%;
    height: 300px;
    overflow: hidden;
    margin-bottom: 20px;
}

.dish-big-photo {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.nutrition-card {
    height: 100%;
}

.nutrition-card-header {
    font-weight: bold;
    color: #666;
}

.nutrition-card-value {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin: 10px 0;
}

.nutrition-card-desc {
    font-size: 12px;
    color: #999;
}

.introduction-container {
    padding: 20px;
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;
}

.introduction-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.introduction-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #f0f0f0;
}

.introduction-text {
    line-height: 1.8;
    color: #666;
    font-size: 14px;
    white-space: pre-line;
}

.no-introduction {
    color: #999;
    text-align: center;
    padding: 30px 0;
    font-style: italic;
}

.features-container {
    margin-top: 25px;

    .features-title {
        font-size: 16px;
        font-weight: 500;
        color: #333;
        margin-bottom: 12px;
    }
}

.features-tags {
    display: flex;
    flex-wrap: wrap;
}
</style>